

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const EDITUSERINFO= createAsyncThunk(
  "editUserInfo/editUserInfo",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const editUserInfoSlice = createSlice({
  name: "editUserInfoSlice",
  initialState: {
    editUserInfo: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfeditUserInfo: (state) => {
        state.editUserInfo.loading = false
        state.editUserInfo.error = false
        state.editUserInfo.data = []
        state.editUserInfo.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(EDITUSERINFO.fulfilled, (state, action) => {
      state.editUserInfo = {
        ...state.editUserInfo,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(EDITUSERINFO.pending, (state, action) => {
      state.editUserInfo = {
        ...state.editUserInfo,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(EDITUSERINFO.rejected, (state, action) => {
      state.editUserInfo = {
        ...state.editUserInfo,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const editUserInfoAction = {
    EDITUSERINFO,
};

export { editUserInfoAction };
export default editUserInfoSlice.reducer;
export const {setInitialStateOfeditUserInfo} = editUserInfoSlice.actions
